export default {
  primary: {
    base: '#56544d',
    darken1: '#000000',
    lighten1: '#dad7cf'
  },
  secondary: {
    base: '#0089a6',
    lighten1: '#36a5c4'
  },
  accent: '#f36534',
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  highlight: {
    base: '#dad0b1'
  },
  backbox: {
    base: '#f6f6f6'
  }
}